import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../../../environments/environment";
// import { log } from "console";

@Component({
  selector: "app-college-news-list",
  templateUrl: "./college-news-list.component.html",
  styleUrls: ["./college-news-list.component.scss"],
})
export class CollegeNewsListComponent implements OnInit {
  public list = [];
  message = null;
  class = null;

  constructor(private router: Router, private http: HttpClient) {}

  public settings = {
    actions: {
      position: "right",
      add: false,
      edit: false,
      delete: localStorage.getItem("userRole") == "admin" ? true : false,
    },
    delete: {
      confirmDelete: true,
    },
    columns: {
      title: {
        title: "News Title",
      },
      newsdate: {
        title: "News Date",
      },

      _id: {
        title: "Edit",
        type: "html",
        valuePrepareFunction: (cell, row) => {
          return `<a href="college-details/edit-college-news/${row._id}"  class="ng2-smart-action ng2-smart-action-edit-edit ng-star-inserted"><i class="fa fa-pencil"></i></a>&nbsp; 
         `;
        },
        filter: false,
      },
    },
  };

  ngOnInit() {
    let role = localStorage.getItem("userRole");
    let user = localStorage.getItem("userId");
    if (role == "admin") {
      this.http
        .get<any>(`${environment.apiUrl}/collegenews/`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            data.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            this.list = data.results;
            console.log(this.list);
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    } else {
      this.http
        .get<any>(`${environment.apiUrl}/collegenews/${user}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            data.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            this.list = data.data;
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    }
  }

  deleteRecord(event) {
    // console.log(event);

    if (confirm("Are You Sure?")) {
      this.http
        .delete<any>(`${environment.apiUrl}/collegenews/${event.data._id}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            data.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (data.status == "500") {
              this.message = data.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Deleted";
              this.class = "btn-success rounded px-1 py-1";
              this.ngOnInit();
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    }
  }
}
